import React, { useState, useEffect } from 'react';
import OrganizationList from './OrganizationList';
import OrganizationDetail from './OrganizationDetail';
import OrganizationForm from './OrganizationForm';
import { useLanguage } from '../../contexts/LanguageContext';
import './OrganizationManagement.scss';

// activeView prop App.js'ten (Sidebar tıklamalarından) gelir: 'org-list' | 'org-create'
const OrganizationManagement = ({ activeView }) => {
    const { t } = useLanguage();
    const [selectedOrg, setSelectedOrg] = useState(null);
    const [view, setView] = useState(activeView === 'org-create' ? 'create' : 'list');

    // Sidebar'dan tekrar tıklanınca (ör. detay ekranındayken "Yeni Kurum Ekle") görünüm senkron kalsın
    useEffect(() => {
        setView(activeView === 'org-create' ? 'create' : 'list');
        setSelectedOrg(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeView]);

    const handleOrgSelect = (org) => {
        setSelectedOrg(org);
        setView('detail');
    };

    const handleBackToList = () => {
        setView('list');
        setSelectedOrg(null);
    };

    return (
        <div className="organization-management-container">
            {view === 'list' && (
                <OrganizationList onOrgSelect={handleOrgSelect} onCreateNew={() => setView('create')} />
            )}

            {view === 'create' && (
                <OrganizationForm onCreated={handleBackToList} onCancel={handleBackToList} />
            )}

            {view === 'detail' && selectedOrg && (
                <div>
                    <button onClick={handleBackToList} className="back-button">← {t('backToOrganizationList')}</button>
                    <OrganizationDetail org={selectedOrg} />
                </div>
            )}
        </div>
    );
};

export default OrganizationManagement;
